import { Directive, ElementRef, Input, Renderer2, OnInit } from '@angular/core';

@Directive({
  selector: '[dynamicAttributes]'
})
export class DynamicAttributesDirective implements OnInit {
  @Input() dynamicAttributes: { [key: string]: string };

  constructor(
    public element: ElementRef<HTMLElement>,
    private renderer: Renderer2)
  { }

  ngOnInit(): void {
    const attrs = Object.keys(this.dynamicAttributes).map(key => ({ key, val: this.dynamicAttributes[key] }));

    attrs.forEach(item => {
      if (!item.key.startsWith('(')
      && !item.key.startsWith('[')
      && !item.key.startsWith('_')) {
        this.renderer.setAttribute(this.element.nativeElement, item.key, item.val);
      }
    });
  }
}
